// extracted by css-extract-rspack-plugin
export default {"PromptActions":"AskCopilotNoReadmeCard-module__PromptActions__EOAji"};